import { makeStyles, Theme } from "@material-ui/core";

import { getTypeIconColor, RollupsItemType } from "../helpers";

const getLevelSpace = (level: 0 | 1 | 2) =>
  ({
    0: 22,
    1: 48,
    2: 77
  }[level]);

export const useStyles = makeStyles<
  Theme,
  {
    level: 0 | 1 | 2;
    type: RollupsItemType;
    label: string;
    spacing: number;
    disabled?: boolean;
    height?: number;
    withCheckbox?: boolean;
  }
>(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    paddingLeft: ({ level, withCheckbox }) =>
      getLevelSpace(level) - (withCheckbox ? 9 : 0),
    paddingTop: ({ label, spacing }) =>
      label === "Ungrouped Projects" ? 10 : spacing,
    paddingBottom: ({ label, spacing }) =>
      label === "Ungrouped Projects" ? 5 : spacing,
    width: "100%",
    height: ({ height }) => height,
    opacity: ({ disabled }) => (disabled ? 0.6 : 1)
  },

  icon: {
    marginRight: 10,
    color: ({ type }) => getTypeIconColor(type, theme),
    lineHeight: 0
  },

  label: {
    fontWeight: ({ type, label }) =>
      type === "project" && label !== "Ungrouped Projects" ? 500 : 600,
    color: theme.palette.text.secondary
  },

  currentLabel: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginRight: 3
  }
}));
